export const getLastElOfArr = arr => arr[arr.length - 1];
